import { virtualDir } from "#skyward_global";
import { ButtonDefinition, ButtonIcon, ButtonText, ModalDialogSettings, showDialog } from "#skyward_modalLayer";
import { loadContent } from "#skyward_window";
import { registerEvents } from "./skyward.ui.events";
import { JQueryInput } from "./types";
import { ThemeSelectorClasses, ThemeSelectorDataKeys } from "./vue/skyVue/themeSelector/classes";
import { themeSelectorStore } from "./vue/skyVue/themeSelector/store";
import { ThemeSelectorStoreState } from "./vue/skyVue/themeSelector/store/types";

const events =
{
    build: function (this: JQueryInput) { build(this); }
};

registerEvents("themeSelector", events)

let pageStylesheet = $(`.${ThemeSelectorClasses.ThemeStyleSheet}`);

export async function build(button: JQueryInput)
{
    const changeThemeButton = $(button);
    const resetButton: ButtonDefinition = { text: "Reset to Default Theme", click: resetToDefault, icon: "Undo" };
    const saveButton: ButtonDefinition = { text: ButtonText.Save, click: saveUsersTheme, icon: ButtonIcon.Save };
    const cancelButton: ButtonDefinition = { text: ButtonText.Cancel, click: "close", icon: ButtonIcon.Cancel };
    const options: ModalDialogSettings =
    {
        draggable: true,
        closeOnClick: false,
        dynamicDialogContentSelector: `.${ThemeSelectorClasses.Container}`,
        additionalContainerClasses: ThemeSelectorClasses.Modal,
        initialFocusElement: `.${ThemeSelectorClasses.ItemSelected}`,
        beforeClose: revertToPreviousTheme
    };

    const themeSelector = await $.ajax(
        {
            type: "POST",
            url: `${virtualDir}SkySys/Theme/GetThemeSelector`
        });

    const result = $(themeSelector);

    const dialog = showDialog("Themes", () => result, [resetButton, saveButton, cancelButton], options);

    function resetToDefault()
    {
        const container = dialog.content.find(`.${ThemeSelectorClasses.Container}`);

        if (container.length > 0)
        {
            container[0].dispatchEvent(new CustomEvent("resetTheme"));
        }
    }

    async function revertToPreviousTheme()
    {
        const state = await themeSelectorStore.getStateAsync("ThemeSelector") as ThemeSelectorStoreState;

        if (state && state.data.isLoaded)
        {
            const originalApplyGrayScaleFilter = state.data.nonPageableValues.applyGrayScaleFilter;

            if (originalApplyGrayScaleFilter)
            {
                document.documentElement.style.filter = "grayscale(1)";
            }
            else
            {
                document.documentElement.style.filter = "grayscale(0)";
            }

            $(`.${ThemeSelectorClasses.TempCSS}`).remove();

            $(document.body).trigger("themeSwap");
        }
    }

    async function saveUsersTheme()
    {
        const state = await themeSelectorStore.getStateAsync("ThemeSelector") as ThemeSelectorStoreState;
        if (!state || !state.data.isLoaded)
        {
            dialog.close();
            return;
        }

        const tempCss = $(`.${ThemeSelectorClasses.TempCSS}`);
        const grayscaleIsApplied = document.documentElement.style.filter === "grayscale(1)";
        const grayScaleIsDirty = grayscaleIsApplied != state.data.nonPageableValues.applyGrayScaleFilter;
        if (tempCss.length === 0 && !grayScaleIsDirty)
        {
            dialog.close();
            return;
        }

        const currentCSSThemeId = tempCss.length > 0
            ? tempCss.last().data(ThemeSelectorDataKeys.ThemeID)
            : pageStylesheet.data(ThemeSelectorDataKeys.ThemeID);

        await $.ajax(
            {
                type: "POST",
                dataType: "text",
                url: `${virtualDir}Common/Css/SaveUsersTheme`,
                data:
                {
                    tid: currentCSSThemeId,
                    applyGrayScaleFilter: grayscaleIsApplied
                }
            });

        if (tempCss.length > 0)
        {
            const lastTempCss = tempCss.last();
            
            pageStylesheet.remove();

            lastTempCss.removeClass(ThemeSelectorClasses.TempCSS);
            lastTempCss.addClass(ThemeSelectorClasses.ThemeStyleSheet);
            lastTempCss.attr("id", "ThemeCSS");

            pageStylesheet = lastTempCss;
        }

        dialog.close();

        const data = changeThemeButton.data();
        if (data.reloadAfterSave)
        {
            loadContent(data.target, data.area, data.controller, data.action, data.id);
        }
    }
}
